<template>
  <div class="prosedur align-items-center mx-2 d-flex justify-content-center">
    <div
      class="main-content d-flex p-3 flex-column justify-content-center align-items-center"
      style="gap: 16px"
    >
      <img :src="qrImgSrc" alt="qr" style="border-radius: 20px" class="w-100" />

      <p class="f-Overpass f-c-white f-w-600 f-16 m-0">
        {{ formatNoTelp("0" + noTelp) }}
      </p>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "procedureCard",
  props: {
    qrImgSrc: String,
  },
  data() {
    return {
      noTelp: 0,
    };
  },

  methods: {
    ...mapActions({
      getNomorCustomer: "topup/getNomorCustomer",
    }),

    formatNoTelp(noTelp) {
      const format = /\B(?=(\d{4})+(?!\d))/g;
      return noTelp.replace(format, " ");
    },
  },
  mounted() {
    this.getNomorCustomer().then((res) => {
      this.noTelp = res.data.data.customer_global.telp;
    });
  },
};
</script>

<style scoped>
.prosedur {
  border-radius: 16px;
  background: linear-gradient(
    150deg,
    #206cfe -3.8%,
    rgba(0, 38, 148, 0.76) 127.29%
  );
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.15);
}
</style>
